import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  variant?: 'solid' | 'outline';
  className?: string;
};
export function CtaButton({
  children,
  href = '#precio',
  variant = 'solid',
  className = ''
}: CtaButtonProps) {
  const base = 'inline-flex items-center justify-center rounded-full px-8 py-4 font-sans text-sm sm:text-base font-medium tracking-wide transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-cream';
  const styles = variant === 'solid' ? 'bg-gold text-ivory shadow-sm hover:bg-gold-deep hover:shadow-md hover:-translate-y-0.5' : 'border border-gold/60 text-ink hover:bg-gold-soft/25 hover:border-gold';
  return <a href={href} className={`${base} ${styles} ${className}`} data-id="element-21" data-mp="19b1l1t0iu41f">
      {children}
    </a>;
}